export default "__VITE_ASSET__lWTgPrPG__"